export const REAL_RISK_LIMIT_STORAGE_KEY = 'KITE_REAL_RISK_LIMIT_PERCENT';
export const DEFAULT_RISK_PRESET_STORAGE_KEY = 'KITE_DEFAULT_RISK_PRESET_PERCENT';
export const REAL_WALLET_OVERRIDE_STORAGE_KEY = 'KITE_REAL_WALLET_OVERRIDE';
export const POSITION_SIZING_PRESETS_STORAGE_KEY = 'KITE_POSITION_SIZING_PRESETS';
export const POSITION_SIZING_PRESET_START_STORAGE_KEY = 'KITE_POSITION_SIZING_PRESET_START';
export const POSITION_SIZING_PRESET_END_STORAGE_KEY = 'KITE_POSITION_SIZING_PRESET_END';
export const RISK_PRESET_OPTIONS = [0.125, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 2.5, 3, 4, 5];

export function normalizeRiskPresetOptions(values) {
  const sourceValues = Array.isArray(values)
    ? values
    : String(values || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

  const normalized = sourceValues
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value) && value > 0 && value <= 100)
    .map((value) => Number(value.toFixed(3)));

  const uniqueSorted = Array.from(new Set(normalized)).sort((left, right) => left - right);
  return uniqueSorted.length > 0 ? uniqueSorted : [...RISK_PRESET_OPTIONS];
}

export function buildRiskPresetRange(startValue, endValue) {
  const fallbackStart = RISK_PRESET_OPTIONS[0];
  const fallbackEnd = RISK_PRESET_OPTIONS[RISK_PRESET_OPTIONS.length - 1];
  const normalizedStart = RISK_PRESET_OPTIONS.includes(Number(startValue)) ? Number(startValue) : fallbackStart;
  const normalizedEnd = RISK_PRESET_OPTIONS.includes(Number(endValue)) ? Number(endValue) : fallbackEnd;
  const rangeStart = Math.min(normalizedStart, normalizedEnd);
  const rangeEnd = Math.max(normalizedStart, normalizedEnd);
  const rangedPresets = RISK_PRESET_OPTIONS.filter((value) => value >= rangeStart && value <= rangeEnd);
  return rangedPresets.length > 0 ? rangedPresets : [...RISK_PRESET_OPTIONS];
}

export function loadTradingPreferences() {
  const realRiskLimit = Number(localStorage.getItem(REAL_RISK_LIMIT_STORAGE_KEY));
  const defaultRiskPreset = Number(localStorage.getItem(DEFAULT_RISK_PRESET_STORAGE_KEY));
  const riskPresetOptionsRaw = localStorage.getItem(POSITION_SIZING_PRESETS_STORAGE_KEY);
  const riskPresetStart = Number(localStorage.getItem(POSITION_SIZING_PRESET_START_STORAGE_KEY));
  const riskPresetEnd = Number(localStorage.getItem(POSITION_SIZING_PRESET_END_STORAGE_KEY));
  const legacyRiskPresetOptions = normalizeRiskPresetOptions(riskPresetOptionsRaw);
  const riskPresetRangeStart = RISK_PRESET_OPTIONS.includes(riskPresetStart)
    ? riskPresetStart
    : (legacyRiskPresetOptions[0] ?? RISK_PRESET_OPTIONS[0]);
  const riskPresetRangeEnd = RISK_PRESET_OPTIONS.includes(riskPresetEnd)
    ? riskPresetEnd
    : (legacyRiskPresetOptions[legacyRiskPresetOptions.length - 1] ?? RISK_PRESET_OPTIONS[RISK_PRESET_OPTIONS.length - 1]);
  const riskPresetOptionsConfig = buildRiskPresetRange(riskPresetRangeStart, riskPresetRangeEnd);

  return {
    realRiskLimitPercentConfig: Number.isFinite(realRiskLimit) && realRiskLimit > 0 ? realRiskLimit : 2,
    riskPresetRangeStart,
    riskPresetRangeEnd,
    defaultRiskPresetConfig: riskPresetOptionsConfig.includes(defaultRiskPreset)
      ? defaultRiskPreset
      : (riskPresetOptionsConfig[0] ?? 0.5),
    riskPresetOptionsConfig,
    realWalletOverrideInput: localStorage.getItem(REAL_WALLET_OVERRIDE_STORAGE_KEY) || '',
  };
}

export function saveTradingPreferences(preferences) {
  const normalizedRiskPresetOptions = buildRiskPresetRange(
    preferences.riskPresetRangeStart,
    preferences.riskPresetRangeEnd,
  );
  const defaultRiskPreset = normalizedRiskPresetOptions.includes(Number(preferences.defaultRiskPresetConfig))
    ? Number(preferences.defaultRiskPresetConfig)
    : normalizedRiskPresetOptions[0];

  localStorage.setItem(REAL_RISK_LIMIT_STORAGE_KEY, String(preferences.realRiskLimitPercentConfig));
  localStorage.setItem(POSITION_SIZING_PRESET_START_STORAGE_KEY, String(normalizedRiskPresetOptions[0]));
  localStorage.setItem(POSITION_SIZING_PRESET_END_STORAGE_KEY, String(normalizedRiskPresetOptions[normalizedRiskPresetOptions.length - 1]));
  localStorage.setItem(POSITION_SIZING_PRESETS_STORAGE_KEY, normalizedRiskPresetOptions.join(','));
  localStorage.setItem(DEFAULT_RISK_PRESET_STORAGE_KEY, String(defaultRiskPreset));
  localStorage.setItem(REAL_WALLET_OVERRIDE_STORAGE_KEY, String(preferences.realWalletOverrideInput));
}
